export const SITE_DOMAIN = "restorationroofingremodeling.com";

export const GMB_FALLBACK_AGGREGATE_RATING = 4.9;
export const GMB_FALLBACK_RATING_COUNT = 77;

// Proxied through setupProxy.js (dev) and PHP scripts in public/api/gmb (production).
export const GMB_REVIEWS_API = "/api/gmb/reviews";

export const GMB_AGGREGATED_API = "/api/gmb/aggregated";

export const GOOGLE_REVIEWS_URL =
  "https://www.google.com/search?q=Restoration+Roofing+%26+Remodeling+LLC&stick=H4sIAAAAAAAA_-NgU1I1qLAwMzE3NjY3NTVItjRJMja2MqgwTzVPNE-ytEgxsUxJSUpJXsSqEpRaXJJflFiSmZ-nEJSfn5aZl66gphCUmpufkpoD4vj4OAMAkNExLVAAAAA&hl=en-GB&mat=CcCMDsssubqeElYBa0lj_9tfne2FNtGy4Fv7JfEQF3aDIeTHP6hjaINz-YL9hF0fJPt0NpahV4MLqYB-eJTn3pW-BBXK38SJNufzP2FNy137ouI8LqoUwz8zklq3ubIhxA&authuser=0";
